import axios from "axios";
import { useEffect, useState } from "react";
import { getSecureUser } from "../utils/secureStorage";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Typography,
  Box
} from "@mui/material";
import { FaCheckCircle, FaTimesCircle, FaRedo } from "react-icons/fa";

function ViewCanceledCourse() {
  const [viewCancelEnrollCourse, setViewCancelEnrollCourse] = useState([]);

  useEffect(() => {
    const userData = getSecureUser();
    const url = `${process.env.REACT_APP_API}/enrollment/view_cancel/${userData.id}`;
    axios.get(url, { withCredentials: true }).then((res) => {
      setViewCancelEnrollCourse(res.data.data);
    });
  }, []);

  const handleReEnroll = (enrollId) => {
    const url = `${process.env.REACT_APP_API}/enrollment/renroll/${enrollId}`;
    axios
      .put(url, {}, { withCredentials: true })
      .then((res) => {
        setViewCancelEnrollCourse((prev) =>
          prev.filter((course) => course.enrolment_id !== enrollId)
        );
      })
      .catch((error) => {
        console.error("Re-enroll failed:", error);
      });
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom align="center">
        Cancelled Courses
      </Typography>

      {viewCancelEnrollCourse.length > 0 ? (
        <TableContainer
          component={Paper}
          sx={{ mt: 3, boxShadow: 3, borderRadius: 2 }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#9c27b0" }}>
                {[
                  "S.No",
                  "Course Name",
                  "Enrollment Status",
                  "Course Status",
                  "Cancelled Date",
                  "Paid Status",
                  "Fee",
                  "Re-Enroll"
                ].map((title, i) => (
                  <TableCell
                    key={i}
                    sx={{
                      fontWeight: "bold",
                      fontSize: "0.7rem",
                      backgroundColor: "#1050A2",
                      color: "white",
                      px: 1,
                      textAlign: "center"
                    }}
                  >
                    {title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {viewCancelEnrollCourse.map((data, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
                    "&:hover": { backgroundColor: "#f3e5f5" }
                  }}
                >
                  <TableCell sx={{ textAlign: "center" }}>{index + 1}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{data.name}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{data.enrolment_status}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{data.course_status}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{data.cancelled_date || "—"}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {data.course_paid_status ? (
                      <Tooltip title="Paid">
                        <FaCheckCircle color="green" />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Not Paid">
                        <FaTimesCircle color="red" />
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {data.fee}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <Tooltip title="Re-Enroll">
                      <IconButton
                        color="primary"
                        onClick={() => handleReEnroll(data.enrolment_id)}
                      >
                        <FaRedo />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography
          align="center"
          mt={10}
          fontSize="1.8rem"
          fontWeight={500}
          color="text.secondary"
        >
          No cancelled courses to display.
        </Typography>
      )}
    </Box>
  );
}

export default ViewCanceledCourse;
